import React from 'react';
import Button from 'material-ui/Button';
import { withStyles } from 'material-ui/styles';
import { LinearProgress } from 'material-ui/Progress';
import OLYWebPageComponent from '../OLYWebPageComponent';
import { getValuation, postReservation } from '../../services/transfersService';
import { translate } from 'react-i18next';
import ReservationPricesRender from '../Reservation/ReservationPricesRender';
import ReservationHolderRender from '../Reservation/ReservationHolderRender';
import InformationPanel from '../../ui/InformationPanel';
import TransferDetailRender from './TransferDetailRender';
import TinyFlightRender from '../Reservation/Flight/TinyFlightRender';
import ReservationCancelDetailsRender from '../Reservation/ReservationCancelDetailsRender';
import { getValidator } from '../Reservation/Validators/ClientLocatorFactory';

const styles = theme => ({
    tableTitle: {
        color: theme.palette.primary.main,
        fontSize: 24,
        fontWeight: 300
    },
    inputLabel: {
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        color: '#3155A1',
    },
    disabled: {
        pointerEvents: 'none',
        /* for "disabled" effect */
        opacity: '0.5',
        backgroundColor: '#CCC',
    }
});
class TransfersConfirmm extends OLYWebPageComponent {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            reservation: null,
            cancelationsAccepted: false,
            originFromMtpEmpty: true,
            originToMtpEmpty: true,
            destinationFromMtpEmpty: true,
            destinationToMtpEmpty: true,
            formHolderError: true,
            errors: {
                clientLocator: true
            }
        };
        this.pageName = 'TransfersConfirmm';
        this.flightInformationValid = false;

        this.clientLocatorValidator = getValidator(this.currentUser.accountName);
    }

    onHashChanged = (hash) => {
        if (hash && hash.parts) {
            let result_key = hash.parts[3];
            this.setState({ resultToken: result_key },
                () => this.getServerResult());
        }
    }

    componentDidMount() {
        super.componentDidMount();
        window.scrollTo(0, 0);
    }

    getServerResult = () => {
        let key = this.state.resultToken;
        this.setState({ loading: true, error: null });
        getValuation(key, null).then(data => {
            //console.log(this.currentUser);
            let airport = data.valuationResult.fromDetails.airport;
            if (airport) {
                data.flightinformation.airport = airport;
            }
            this.setState({
                reservation: data,
                error: null,
            }, () => {
                this.validateMeetingPoints();
            });
        }).catch(e => {
            this.setState({ error: e.message + '\n' + (e.detailedMessage || '') });
        }).then(() => {
            this.setState({ loading: false });
        });
    }

    submit = () => {
        console.log(this.state.reservation);
        this.setState({ loading: true, error: null, errors: {} });
        postReservation(this.state.reservation).then(data => {
            this.setState({ error: null, loading: false }, () => {
                window.location.href = '#/bookings/' + data.GenerateLocator.Locator + '/view';
            });
        }).catch(e => {
            //console.log(e);
            //alert(e.message + '\n' + (e.detailedMessage || ''));
            let newState = this.state;
            newState.loading = false;
            this.addErrorsToStateObject(e, newState);
            newState.error = e.message + '\n' + (e.detailedMessage || '');
            this.setState(newState);
        });
    }

    setHolder(prop, value) {
        let rr = this.state.reservation;
        rr.holder[prop] = value;
        const formHolderError = this.validateHolder(rr.holder);
        this.setState({ reservation: rr, formHolderError });
    }

    validateHolder(holder) {
        //que el nombre no este vacio
        let invalid = true;
        const firstNameIsNotEmpty = holder.name && String(holder.name).match(/^(?!\s*$).+/);
        let lastNameIsNotEmpty = holder.lastname && String(holder.lastname).match(/^(?!\s*$).+/);
        if (firstNameIsNotEmpty && lastNameIsNotEmpty) {
            invalid = false;
        }
        return invalid;
    }

    setObservations(value) {
        let rr = this.state.reservation;
        rr.clientObservation = value;
        this.setState({ reservation: rr });
    }

    setClientLocator(value) {
        let newState = this.state;
        newState.reservation.clientLocator = value;
        try {
            this.clientLocatorValidator.validate(value);
            newState.errors.clientLocator = false;
        } catch (error) {
            newState.errors.clientLocator = true;
        }
        this.setState(newState);
    }

    acceptCancelations = (value) => {
        this.setState({ cancelationsAccepted: value });
    }

    setMeetingPoint = (value, method) => {
        if (method && this['set' + method + 'MeetingPoint']) {
            this['set' + method + 'MeetingPoint'](value);
        } else if (method) {
            console.log('Trying to access method ' + method);
        }
    }

    validateMeetingPoints = () => {
        let rr = this.state.reservation;
        this.setState({
            originFromMtpEmpty: rr.valuationResult.fromDetails.originMeetingPoint.code === '',
            destinationFromMtpEmpty: rr.valuationResult.fromDetails.destinationMeetingPoint.code === '',
            originToMtpEmpty: rr.valuationResult.toDetails ? rr.valuationResult.toDetails.originMeetingPoint.code === '' : false,
            destinationToMtpEmpty: rr.valuationResult.toDetails ? rr.valuationResult.toDetails.destinationMeetingPoint.code === '' : false,
        });
    }

    setFromOriginMeetingPoint = (value) => {
        let rr = this.state.reservation;
        rr.valuationResult.fromDetails.originMeetingPoint.code = value.code;
        rr.valuationResult.fromDetails.originMeetingPoint.name = value.name;
        this.setState({ reservation: rr }, () => {
            this.validateMeetingPoints();
        });
    }

    setFromDestinationMeetingPoint = (value) => {
        let rr = this.state.reservation;
        rr.valuationResult.fromDetails.destinationMeetingPoint.code = value.code;
        rr.valuationResult.fromDetails.destinationMeetingPoint.name = value.name;
        this.setState({ reservation: rr }, () => {
            this.validateMeetingPoints();
        });
    }

    setToOriginMeetingPoint = (value) => {
        let rr = this.state.reservation;
        rr.valuationResult.toDetails.originMeetingPoint.code = value.code;
        rr.valuationResult.toDetails.originMeetingPoint.name = value.name;
        this.setState({ reservation: rr }, () => {
            this.validateMeetingPoints();
        });
    }

    setToDestinationMeetingPoint = (value) => {
        let rr = this.state.reservation;
        rr.valuationResult.toDetails.destinationMeetingPoint.code = value.code;
        rr.valuationResult.toDetails.destinationMeetingPoint.name = value.name;
        this.setState({ reservation: rr }, () => {
            this.validateMeetingPoints();
        });
    }

    isSomeMtpEmpty() {
        let rr = this.state.reservation;
        let EmptyItems = rr.valuationResult.toDetails ? 4 : 2;
        if (rr.valuationResult.fromDetails.originMeetingPoint.code !== '') {
            EmptyItems--;
        }
        if (rr.valuationResult.fromDetails.destinationMeetingPoint.code !== '') {
            EmptyItems--;
        }
        if (rr.valuationResult.toDetails) {
            if (rr.valuationResult.toDetails.originMeetingPoint.code !== '') {
                EmptyItems--;
            }
            if (rr.valuationResult.toDetails.destinationMeetingPoint.code !== '') {
                EmptyItems--;
            }
        }
        if (this.flightInformationRequired()) {
            //requiere vuelo ida
            let finfo = this.state.reservation.flightinformation;
            if (this.state.reservation.FLIGTH_DATA_REQUIRED >= 1) {
                //
                if (finfo.airport === '') {
                    EmptyItems++;
                }
                if (finfo.forth.flightNumber === '') {
                    EmptyItems++;
                }
            }
            //require vuelo ida y vuelta
            if (this.state.reservation.FLIGTH_DATA_REQUIRED >= 2) {
                //
                if (finfo.back.flightNumber === '') {
                    EmptyItems++;
                }
            }
        }
        try {
            this.clientLocatorValidator.validate(rr.clientLocator);
        } catch (error) {
            EmptyItems++;
        }
        ///console.log('EmptyItems: ' + EmptyItems, EmptyItems == 0);
        return EmptyItems == 0;
    }

    flightInformationRequired = () => {
        const val = this.state && this.state.reservation && this.state.reservation.FLIGTH_DATA_REQUIRED != 0;
        return val;
    }

    onTinyFlightRenderFocusOut = () => {
        let st = this.state;
        st.bla = 2;
        this.setState(st);
    }

    disableConfirmButton = () => {
        return this.state.loading || !this.isSomeMtpEmpty() || this.state.formHolderError || !this.state.cancelationsAccepted;
    }

    render() {
        const { t, classes } = this.props;
        return (
            <div className="cmsConfirmation">
                {this.state.loading ? <LinearProgress className="cmsProgressBar" /> : ''}
                <div className="cmsContainer">
                    <div>
                        <div>
                            <div>
                                <div className="TransferRender">
                                    {
                                        this.state.reservation ?
                                            <TransferDetailRender
                                                currentUser={this.currentUser}
                                                transfer={this.state.reservation}
                                                setMeetingPoint={this.setMeetingPoint}
                                                originMtpFromError={this.state.originFromMtpEmpty}
                                                originMtpToError={this.state.originToMtpEmpty}
                                                destinationMtpFromError={this.state.destinationFromMtpEmpty}
                                                destinationMtpToError={this.state.destinationToMtpEmpty}
                                            />
                                            : ''
                                    }
                                </div>
                                <div className="cmsReservationData">
                                    <ReservationPricesRender
                                        reservation={this.state.reservation}
                                        onlyShowPVP={false}
                                        onlyShowSalesPrice={true}
                                    />
                                    <ReservationHolderRender
                                        onChangeClientLocator={value => {
                                            this.setClientLocator(value);
                                        }}
                                        clientLocatorError={this.state.errors.clientLocator}
                                        clientLocatorErrorText={this.state.errors.clientLocatorDescription}
                                        error={this.state.formHolderError}
                                        onChange={(value, type) => {
                                            this.setHolder(type, value);
                                        }}
                                        onChangeObservations={value => {
                                            this.setObservations(value);
                                        }}
                                        reservation={this.state.reservation}
                                    />
                                    {
                                        this.state.reservation && this.state.reservation.flightinformation && this.flightInformationRequired() ?
                                            <TinyFlightRender
                                                required={this.flightInformationRequired()} viewOnlyMode={false}
                                                onBlur={this.onTinyFlightRenderFocusOut}
                                                requiredItems={this.state.reservation.FLIGTH_DATA_REQUIRED}
                                                flightinformation={this.state.reservation.flightinformation}
                                            />
                                            : <br />
                                    }
                                </div>
                                <div>
                                    <ReservationCancelDetailsRender reservation={this.state.reservation}
                                        onCheck={this.acceptCancelations}
                                        viewOnlyMode={false} />
                                    <div>
                                        {this.state.loading ? <LinearProgress className="cmsProgressBar" /> : ''}
                                    </div>
                                    {this.state.error ? (
                                        <InformationPanel
                                            type="error"
                                            title='Error'
                                            text={this.state.error}
                                        />
                                    ) : (
                                            ''
                                        )}
                                    <div style={{ margin: '0 auto', display: 'table', paddingBottom: '10px' }}>
                                        <Button
                                            className="confirmTransfer"
                                            variant="raised"
                                            color="secondary"
                                            disabled={this.disableConfirmButton()}
                                            onClick={this.submit}
                                            size={'large'}>
                                            {t('CONFIRM_BOOKING.BOOKING_BUTTON')}
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
export default translate('translations')(withStyles(styles)(TransfersConfirmm));


// WEBPACK FOOTER //
// ./src/components/Transfers/TransfersConfirmm.js